const CONSTANT = require('../../shared/constants')

/**
 * Core module added to store
 * @param options
 * @returns {CancelToken|string|*}
 */
module.exports = (options) => ({
  namespaced: true,
  state: {
    history: [],
    nodeToRestore: null
  },
  mutations: {
    /**
     * Update the navigation history accordingly to the current situation.
     * @param {*} state VueX Navik state
     * @param {*} previousNode The node the user is leaving.
     * @param {*} nextNode The node the user is going to.
     * @param {*} mode The navigation mode. If the navigation mode is descendant, then the mode is vertical.
     *                 If it is a navigation between two nodes on the same hierarchial level in the context, then the mode must be horizontal.
     */
    updateNavigationHistory (state, { previousNode, nextNode, mode = CONSTANT.NAVIGATION_MODE.VERTICAL }) {
      // If the next node has the same path as the last entry in history, then we went back so delete the last entry.
      if (state.history.length > 0 && nextNode.fullPath === state.history.slice(-1)[0].fullPath) {
        state.nodeToRestore = state.history.pop()
      } else {
        state.nodeToRestore = null
      }

      // If no backlink available in previous node, consider this as a new journey so clear history
      if (!previousNode.hasBackLink) {
        state.history = []
        state.history.push(previousNode)
      } else if (!state.nodeToRestore || (state.nodeToRestore && !state.nodeToRestore.corner)) {
        // Else, check if the previous node route path already exists in history so cut it if needed.
        const nodeIndex = state.history.findIndex(node => node.fullPath === previousNode.fullPath)

        if (nodeIndex > -1) {
          state.history = state.history.slice(0, nodeIndex)
        }

        // Finally, if the previous node is not a leaf and if the navigation is vertical, we can add it to the history
        if (previousNode.nodeType !== CONSTANT.NODE_TYPE.LEAF && mode === CONSTANT.NAVIGATION_MODE.VERTICAL) {
          state.history.push(previousNode)
        }
      }
    }
  },
  getters: {
    getParentNavigationNode (state) {
      return (state.history.length === 0) ? null : state.history.slice(-1)[0]
    },
    getNodeFromFullPath (state) {
      return (fullPath) => { return state.history.find(node => node.fullPath === fullPath) }
    },
    getNodeToRestore (state) {
      return state.nodeToRestore
    }
  }
})
